import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";


import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { environment } from 'src/environments/environment';
import {
  faTiktok,
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';



@Component({
  selector: 'app-lb-footer',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './lb-footer.component.html',
  styleUrls: ['./lb-footer.component.scss'],
})
export class LbFooterComponent {
  constructor(library: FaIconLibrary) {
    library.addIcons(faLinkedin);
    library.addIcons(faXTwitter);
    library.addIcons(faYoutube);
  }

  navigateToRDNA() {
    window.location.href = `${environment.frontend_base}landing`;
  }

  navigateTo(url:string) {
    window.location.href = url
  }
}
